import { HIDE_QUERY_PARAM } from "@/lib/constants"

export const TABBAR = "tabbar"
export const TOOLBAR = "toolbar"

export default (element, route) => {
  const hiddenElements = (route.query[HIDE_QUERY_PARAM] || "")
    .split(",")
    .filter(h => h)

  return hiddenElements.includes(element)
}
